/**
 * Tabela kalorii (DNZ-356)
 *
 * Every row is rendered server-side and stays in the DOM (all links crawlable).
 * This script only filters (search / category / kcal range) and sorts what is
 * there, plus clones the column header so it stays visible while scrolling.
 * Vanilla JS, no jQuery, because the table can hold ~1000 rows.
 */
(function () {
	'use strict';

	// Cell index -> sort key. Matches the column order rendered by the block.
	var COLUMN_KEYS = ['name', 'cat', 'kcal', 'protein', 'fat', 'sat', 'carb', 'sugar', 'fiber'];
	var COMBINING_MARKS = new RegExp('[\\u0300-\\u036f]', 'g');
	var NON_NUMERIC = /[^0-9,.-]/g;

	/**
	 * Fold a string to lowercase ASCII so "czeresnie" matches "czereśnie".
	 */
	function fold(value) {
		return String(value)
			.toLowerCase()
			.normalize('NFD')
			.replace(COMBINING_MARKS, '')
			.replace(/ł/g, 'l'); // ł has no NFD decomposition
	}

	function parseNumber(value) {
		if (value === '' || value == null) {
			return NaN;
		}
		var n = parseFloat(String(value).replace(',', '.'));
		return isNaN(n) ? NaN : n;
	}

	// Read a numeric value straight from the rendered cell ("27,00 g", "479",
	// "b/d") so the markup carries no redundant data-* attributes.
	function cellNumber(cell) {
		if (!cell) {
			return NaN;
		}
		var n = parseFloat(cell.textContent.replace(NON_NUMERIC, '').replace(',', '.'));
		return isNaN(n) ? NaN : n;
	}

	function debounce(fn, wait) {
		var t;
		return function () {
			var ctx = this;
			var args = arguments;
			clearTimeout(t);
			t = setTimeout(function () {
				fn.apply(ctx, args);
			}, wait);
		};
	}

	function initTable(root) {
		var table = root.querySelector('.calories-table__table');
		var tbody = table ? table.querySelector('tbody') : null;
		var thead = table ? table.querySelector('thead') : null;
		if (!tbody || !thead) {
			return;
		}

		var viewport = root.querySelector('.calories-table__viewport');
		var form = root.querySelector('.calories-table__controls');
		var searchInput = root.querySelector('.calories-table__search');
		var categorySelect = root.querySelector('.calories-table__category');
		var rangeWrap = root.querySelector('.calories-table__control--range');
		var fromNumber = root.querySelector('.calories-table__range-input--from');
		var toNumber = root.querySelector('.calories-table__range-input--to');
		var fromSlider = root.querySelector('.calories-table__slider-input--from');
		var toSlider = root.querySelector('.calories-table__slider-input--to');
		var sliderFill = root.querySelector('.calories-table__slider-fill');
		var resetBtn = root.querySelector('.calories-table__reset');
		var countEl = root.querySelector('.calories-table__count');
		var emptyEl = root.querySelector('.calories-table__empty');
		var headCells = Array.prototype.slice.call(root.querySelectorAll('.calories-table__th'));
		var siteHeader = document.querySelector('.site-header');

		var kcalMin = rangeWrap ? parseNumber(rangeWrap.getAttribute('data-kcal-min')) : 0;
		var kcalMax = rangeWrap ? parseNumber(rangeWrap.getAttribute('data-kcal-max')) : 0;
		if (isNaN(kcalMin)) { kcalMin = 0; }
		if (isNaN(kcalMax) || kcalMax < kcalMin) { kcalMax = kcalMin; }

		// Snapshot every row once, reading values from the rendered cells.
		var rows = Array.prototype.slice.call(tbody.rows).map(function (tr) {
			var cells = tr.cells;
			var link = cells[0] ? cells[0].querySelector('a') : null;
			var search = fold((link || cells[0] || tr).textContent.trim());
			var vals = {};
			for (var i = 2; i < COLUMN_KEYS.length; i++) {
				vals[COLUMN_KEYS[i]] = cellNumber(cells[i]);
			}
			return {
				el: tr,
				search: search,
				cat: tr.getAttribute('data-cat') || '',
				catSort: cells[1] ? fold(cells[1].textContent.trim()) : '',
				vals: vals
			};
		});

		var state = { q: '', cat: '', from: kcalMin, to: kcalMax };

		function rangeActive() {
			return state.from > kcalMin || state.to < kcalMax;
		}

		function anyFilterActive() {
			return state.q !== '' || state.cat !== '' || rangeActive();
		}

		function applyFilters() {
			var q = state.q;
			var cat = state.cat;
			var from = state.from;
			var to = state.to;
			var narrowed = rangeActive();
			var lastShown = null;
			var visible = 0;

			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				var cl = row.el.classList;
				var show = true;

				if (q !== '' && row.search.indexOf(q) === -1) {
					show = false;
				}
				if (show && cat !== '' && row.cat !== cat) {
					show = false;
				}
				if (show && narrowed) {
					var kcal = row.vals.kcal;
					if (isNaN(kcal) || kcal < from || kcal > to) {
						show = false;
					}
				}

				cl.remove('is-last-shown');
				if (show) {
					cl.remove('calories-table__row--hidden');
					visible++;
					lastShown = row.el;
				} else {
					cl.add('calories-table__row--hidden');
				}
			}

			if (lastShown) {
				lastShown.classList.add('is-last-shown');
			}
			if (countEl) {
				countEl.textContent = String(visible);
			}
			if (emptyEl) {
				emptyEl.hidden = visible !== 0;
			}
			if (resetBtn) {
				resetBtn.disabled = !anyFilterActive();
			}
		}

		function refilter() {
			applyFilters();
			positionFloating();
		}

		// --- sorting ------------------------------------------------------

		var compare = {
			text: function (a, b) {
				return a.localeCompare(b, 'pl');
			},
			num: function (a, b) {
				return a - b;
			}
		};

		function sortBy(key, type, dir) {
			var factor = dir === 'desc' ? -1 : 1;
			var sorted = rows.slice().sort(function (ra, rb) {
				var a;
				var b;
				if (type === 'num') {
					a = ra.vals[key];
					b = rb.vals[key];
					var aMissing = isNaN(a);
					var bMissing = isNaN(b);
					if (aMissing && bMissing) { return compare.text(ra.search, rb.search); }
					if (aMissing) { return 1; }   // missing values always last
					if (bMissing) { return -1; }
					if (a === b) { return compare.text(ra.search, rb.search); }
					return factor * compare.num(a, b);
				}
				a = key === 'cat' ? ra.catSort : ra.search;
				b = key === 'cat' ? rb.catSort : rb.search;
				if (a === b) { return compare.text(ra.search, rb.search); }
				return factor * compare.text(a, b);
			});

			var frag = document.createDocumentFragment();
			for (var i = 0; i < sorted.length; i++) {
				frag.appendChild(sorted[i].el);
			}
			tbody.appendChild(frag);
			rows = sorted;
		}

		function onHeadClick(th) {
			var key = th.getAttribute('data-key');
			var type = th.getAttribute('data-type') === 'num' ? 'num' : 'text';
			var current = th.getAttribute('aria-sort');
			var dir = current === 'ascending' ? 'desc' : 'asc';

			headCells.forEach(function (cell) {
				cell.setAttribute('aria-sort', 'none');
				cell.classList.remove('is-sorted-asc', 'is-sorted-desc');
			});
			th.setAttribute('aria-sort', dir === 'asc' ? 'ascending' : 'descending');
			th.classList.add(dir === 'asc' ? 'is-sorted-asc' : 'is-sorted-desc');

			sortBy(key, type, dir);
			refilter();
			syncFloatingState();

			// Belt-and-suspenders: re-pin the clone's horizontal scroll after any
			// implicit focus-scroll settles.
			window.requestAnimationFrame(function () {
				mirrorScroll(viewport, floatCard);
			});
		}

		// --- range control ---------------------------------------------

		function updateSliderFill() {
			if (!sliderFill) { return; }
			var span = kcalMax - kcalMin || 1;
			var left = ((state.from - kcalMin) / span) * 100;
			var right = ((kcalMax - state.to) / span) * 100;
			sliderFill.style.left = left + '%';
			sliderFill.style.right = right + '%';
		}

		function syncRangeInputs() {
			if (fromNumber) { fromNumber.value = state.from; }
			if (toNumber) { toNumber.value = state.to; }
			if (fromSlider) { fromSlider.value = state.from; }
			if (toSlider) { toSlider.value = state.to; }
			updateSliderFill();
		}

		function setRange(from, to) {
			from = Math.round(parseNumber(from));
			to = Math.round(parseNumber(to));
			if (isNaN(from)) { from = kcalMin; }
			if (isNaN(to)) { to = kcalMax; }
			from = Math.min(Math.max(from, kcalMin), kcalMax);
			to = Math.min(Math.max(to, kcalMin), kcalMax);
			if (from > to) {
				var tmp = from;
				from = to;
				to = tmp;
			}
			state.from = from;
			state.to = to;
			syncRangeInputs();
			refilter();
		}

		// --- floating (sticky) column header --------------------------

		var floating = null;
		var floatCard = null;
		var floatInner = null;
		var floatCells = [];

		function buildFloatingHeader() {
			var colgroup = table.querySelector('colgroup');
			floating = document.createElement('div');
			floating.className = 'calories-table__floating';
			floating.setAttribute('aria-hidden', 'true');
			floating.hidden = true;

			// Opaque card, offset from the top by the container's padding so the
			// gap above it never shows the scrolling table. It scrolls horizontally
			// for real (scrollLeft mirrors the viewport) so `position: sticky` on the
			// "Produkt" column keeps working inside it.
			var card = document.createElement('div');
			card.className = 'calories-table__floating-card';
			floatCard = card;

			floatInner = document.createElement('div');
			floatInner.className = 'calories-table__floating-inner';

			var ft = document.createElement('table');
			ft.className = table.className;
			if (colgroup) {
				ft.appendChild(colgroup.cloneNode(true));
			}
			ft.appendChild(thead.cloneNode(true));

			floatInner.appendChild(ft);
			card.appendChild(floatInner);
			floating.appendChild(card);
			// Body, not the block, so an ancestor transform can't break position:fixed.
			document.body.appendChild(floating);

			// Dragging the sticky header sideways scrolls the table too.
			card.addEventListener('scroll', function () {
				mirrorScroll(card, viewport);
			}, { passive: true });

			floatCells = Array.prototype.slice.call(ft.querySelectorAll('.calories-table__th'));
			floatCells.forEach(function (cell, index) {
				var target = cell.querySelector('.calories-table__sort') || cell;
				// Suppress focus: otherwise the browser scrolls the (now really
				// scrollable) card to "reveal" the pressed button from under the
				// sticky Produkt column. The clone is aria-hidden; keyboard users
				// operate the real headers.
				target.addEventListener('pointerdown', function (e) {
					e.preventDefault();
				});
				target.addEventListener('click', function () {
					onHeadClick(headCells[index]);
				});
			});
		}

		function syncFloatingState() {
			if (!floating) { return; }
			for (var i = 0; i < headCells.length && i < floatCells.length; i++) {
				floatCells[i].className = headCells[i].className;
				floatCells[i].setAttribute('aria-sort', headCells[i].getAttribute('aria-sort') || 'none');
			}
		}

		// Bottom edge of the site's own sticky header (when it's pinned at the top),
		// so the cloned table header docks below it instead of covering it.
		function stickyOffset() {
			if (!siteHeader) { return 0; }
			var rect = siteHeader.getBoundingClientRect();
			return (rect.top < 2 && rect.bottom > 0) ? rect.bottom : 0;
		}

		// Breathing room between the site's sticky header and the docked table header.
		var HEADER_GAP = 10;

		function positionFloating() {
			if (!floating || !viewport) { return; }
			var vp = viewport.getBoundingClientRect();
			var headH = thead.getBoundingClientRect().height;
			var offset = stickyOffset();
			var pad = offset > 0 ? HEADER_GAP : 0;
			var dockTop = offset + pad;

			if (vp.top < dockTop && vp.bottom > dockTop + headH + 8) {
				floating.hidden = false;
				floating.style.top = Math.round(offset) + 'px';
				floating.style.paddingTop = pad + 'px';
				floating.style.left = vp.left + 'px';
				floating.style.width = vp.width + 'px';
				floatInner.style.width = table.offsetWidth + 'px';
				mirrorScroll(viewport, floatCard);
			} else if (!floating.hidden) {
				floating.hidden = true;
			}
		}

		// --- listeners ------------------------------------------------

		if (form) {
			form.addEventListener('submit', function (e) {
				e.preventDefault();
			});
		}

		if (searchInput) {
			var runSearch = debounce(function () {
				state.q = fold(searchInput.value.trim());
				refilter();
			}, 120);
			searchInput.addEventListener('input', runSearch);
		}

		if (categorySelect) {
			categorySelect.addEventListener('change', function () {
				state.cat = categorySelect.value;
				refilter();
			});
		}

		if (fromNumber) {
			fromNumber.addEventListener('change', function () {
				setRange(fromNumber.value, state.to);
			});
		}
		if (toNumber) {
			toNumber.addEventListener('change', function () {
				setRange(state.from, toNumber.value);
			});
		}
		if (fromSlider) {
			fromSlider.addEventListener('input', function () {
				setRange(fromSlider.value, Math.max(state.to, parseNumber(fromSlider.value)));
			});
		}
		if (toSlider) {
			toSlider.addEventListener('input', function () {
				setRange(Math.min(state.from, parseNumber(toSlider.value)), toSlider.value);
			});
		}

		headCells.forEach(function (th) {
			var btn = th.querySelector('.calories-table__sort');
			(btn || th).addEventListener('click', function () {
				onHeadClick(th);
			});
		});

		if (resetBtn) {
			resetBtn.addEventListener('click', function () {
				state.q = '';
				state.cat = '';
				if (searchInput) { searchInput.value = ''; }
				if (categorySelect) { categorySelect.value = ''; }
				setRange(kcalMin, kcalMax); // also triggers refilter()
				if (searchInput) { searchInput.focus(); }
			});
		}

		var ticking = false;
		function onScroll() {
			if (ticking) { return; }
			ticking = true;
			window.requestAnimationFrame(function () {
				positionFloating();
				ticking = false;
			});
		}
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		// Two-way horizontal scroll sync between the table viewport and the sticky
		// header clone. `syncingScroll` swallows the echo scroll event the assignment
		// triggers (scroll steps run before the releasing rAF).
		var syncingScroll = false;
		function mirrorScroll(fromEl, toEl) {
			if (syncingScroll || !fromEl || !toEl || !floating || floating.hidden) { return; }
			syncingScroll = true;
			toEl.scrollLeft = fromEl.scrollLeft;
			window.requestAnimationFrame(function () { syncingScroll = false; });
		}
		if (viewport) {
			viewport.addEventListener('scroll', function () {
				mirrorScroll(viewport, floatCard);
			}, { passive: true });
		}

		buildFloatingHeader();
		syncFloatingState();
		syncRangeInputs();
		applyFilters();
		positionFloating();
		root.classList.add('calories-table--ready');
	}

	function init() {
		var tables = document.querySelectorAll('[data-calories-table]');
		for (var i = 0; i < tables.length; i++) {
			initTable(tables[i]);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
